import { render, staticRenderFns } from "./ModalStudentEdit.vue?vue&type=template&id=15f2f31e&scoped=true&lang=pug&"
import script from "./ModalStudentEdit.vue?vue&type=script&lang=ts&"
export * from "./ModalStudentEdit.vue?vue&type=script&lang=ts&"
import style0 from "./ModalStudentEdit.vue?vue&type=style&index=0&id=15f2f31e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f2f31e",
  null
  
)

export default component.exports